import {sendRenewal} from 'malt-webmvc-common/src/main/js/renewal';

Hop.defineModule('signin-fullpage', (root, param) => {
    const $pwdRenewalButton = root.querySelector('.pwd-renewal');

    function send(event) {
        event.preventDefault();
        sendRenewal(param.signinRenewEmailMandatory, param.renewSendSuccess, param.renewSendFailed);
    }

    init();

    function init() {
        root.querySelector('#j_username_component').focus();
        $pwdRenewalButton.addEventListener('click', send);
    }

    return function destroy() {
        $pwdRenewalButton.removeEventListener('click', send);
    };
});
